import {OPTION_CONTAINER_SELECTOR} from './const'

function maybeSetOptionSelected(select, optionIndex: number) {
  if (window.prodify.pickerTypes[`option${optionIndex}`] === 'select') {
    const options = Array.from(select.querySelectorAll('option'))
    const currentValue = select.value

    options.forEach((option: HTMLOptionElement) => {
      if (option.value === currentValue) {
        option.setAttribute('selected', 'selected')
      } else {
        option.removeAttribute('selected')
      }
    })
  }
}

function updateCurrentOptions() {
  window.prodify.optionContainers = Array.from(window.prodify.el.querySelectorAll(OPTION_CONTAINER_SELECTOR))
  window.prodify.options = window.prodify.optionContainers.map((optionContainer, index) => {
    const pickerType = window.prodify.pickerTypes[`option${index + 1}`]
    if (pickerType === 'select') {
      const select = optionContainer.querySelector('select')
      return select ? select.value : ''
    } else {
      const radio = optionContainer.querySelector('input[type="radio"]:checked')
      return radio ? (radio as HTMLInputElement).value : ''
    }
  })
}

export {
  maybeSetOptionSelected,
  updateCurrentOptions
}
